import 'onsenui/css/onsenui.css'; // Onsen UI basic CSS
// import 'onsenui/css/onsen-css-components.css'; // Default Onsen UI CSS components
import './onsen-css-components.css'; // Onsen UI CSS components source for custom themes (requires cssnext)

import Vue from 'vue';
import Vuex from 'vuex';
import VueOnsen from 'vue-onsenui'; // For UMD
// import VueOnsen from 'vue-onsenui/esm'; // For ESM
// import * as OnsenComponents from './onsen-components'; // For ESM
import config from './tools/config.js';
import store from './tools/store.js';
import { i18n } from './tools/i18n.js';

import AppNavigator from './AppNavigator.vue';

window.loggedIn = localStorage.loggedIn ? JSON.parse(localStorage.loggedIn) : false;

window.url_erp = config.url_erp;
window.url_api = config.url_api;

import axios from 'axios'
window.axios = axios
axios.defaults.baseURL = url_api

import emergency_contacts from './data/emergency_contacts.js';
import regions_contacts from './data/regions_contacts.js';
window.regions_contacts = regions_contacts;
window.emergency_contacts = emergency_contacts;

var assets_path = './assets';
window.assets_path = assets_path;
window.card_image = require(assets_path + '/img/card.png');
window.secundo_logo = require(assets_path + '/img/secundo_logo.svg');
window.profile_image = require(assets_path + '/img/profile.png');

Vue.use(Vuex);
Vue.use(VueOnsen);

import CustomToolbar from './partials/CustomToolbar.vue';
Vue.component('custom-toolbar', CustomToolbar);

import { EventBus } from './EventBus.js';

new Vue({
  el: '#app',
  render: h => h(AppNavigator),
  store: new Vuex.Store(store),
  i18n,
  beforeCreate() {
    // Shortcut for Material Design
    Vue.prototype.md = this.$ons.platform.isAndroid();

    // Set iPhoneX flag based on URL
    if (window.location.search.match(/iphonex/i)) {
      document.documentElement.setAttribute('onsflag-iphonex-portrait', '');
      document.documentElement.setAttribute('onsflag-iphonex-landscape', '');
    }
  },
  mounted() {
    if(typeof cordova != 'undefined') {
      document.addEventListener("deviceready", onDeviceReady, false);
      function onDeviceReady() {
        window.open = cordova.InAppBrowser.open;

        document.addEventListener('backbutton', onBackButton, false);
      }

      function onBackButton() {}

    }
    else {
      document.body.classList.add("desktop");
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js